<template>
  <div v-if="hasAny"
       class="vacancy-page__conditions-section">
    <h2 class="vacancy-page__conditions-section-title">{{ $tVacancy('Conditions') }}</h2>

    <div v-if="hasObservationHousing" :class="{_open: isOpen(1)}"
         class="vacancy-page__element  vacancy-element">
      <div class="vacancy-element__head" @click="onToggle(1)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-condition-virus"
                   width="3.2rem"
                   height="3.2rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">
          {{ $tVacancy('Housing for observation') }}
          <template v-if="vacancy[1].conditions_observation_housing_type">
            - {{ vacancy[1].conditions_observation_housing_type.name }}
          </template>
        </h4>
        <div v-if="vacancy[1].conditions_observation_housing" class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>

      <div v-if="vacancy[1].conditions_observation_housing" class="vacancy-element__toggle">
        <div v-html="vacancy[1].conditions_observation_housing"
             class="vacancy-element__text  text"></div>
      </div>
    </div>

    <div v-if="hasHousing" :class="{_open: isOpen(2)}"
         class="vacancy-page__element  vacancy-element">
      <div class="vacancy-element__head" @click="onToggle(2)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-condition-house"
                   width="3.2rem"
                   height="3.2rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">
          {{ $tVacancy('Housing') }}
          <template v-if="vacancy[1].conditions_housing_type">
            - {{ vacancy[1].conditions_housing_type.name }}
          </template>
        </h4>
        <div v-if="vacancy[1].conditions_housing || vacancy[1].conditions_housing_description" class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>

      <div v-if="vacancy[1].conditions_housing || vacancy[1].conditions_housing_description"
           class="vacancy-element__toggle">
        <div v-if="vacancy[1].conditions_housing"
             class="vacancy-element__sub-title">
          {{ vacancy[1].conditions_housing }}
        </div>
        <div v-if="vacancy[1].conditions_housing_description"
             v-html="vacancy[1].conditions_housing_description"
             class="vacancy-element__text  text"></div>
      </div>
    </div>

    <div v-if="hasMeals" :class="{_open: isOpen(3)}"
         class="vacancy-page__element  vacancy-element">
      <div class="vacancy-element__head" @click="onToggle(3)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-condition-cutlery"
                   width="3.2rem"
                   height="3.2rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">
          {{ $tVacancy('Food') }}
          <template v-if="vacancy[1].conditions_meals_type">
            - {{ vacancy[1].conditions_meals_type.name }}
          </template>
        </h4>
        <div v-if="vacancy[1].conditions_meals" class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>

      <div v-if="vacancy[1].conditions_meals"
           class="vacancy-element__toggle">
        <div v-html="vacancy[1].conditions_meals"
             class="vacancy-element__text  text"></div>
      </div>
    </div>

    <div v-if="hasTransport" :class="{_open: isOpen(4)}"
         class="vacancy-page__element  vacancy-element">
      <div class="vacancy-element__head" @click="onToggle(4)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-condition-transport"
                   width="3.2rem"
                   height="3.2rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">
          {{ $tVacancy('Transfer to the working place') }}
          <template v-if="vacancy[1].conditions_transport_type">
            - {{ vacancy[1].conditions_transport_type.name }}
          </template>
        </h4>
        <div v-if="vacancy[1].conditions_transport" class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>

      <div v-if="vacancy[1].conditions_transport"
           class="vacancy-element__toggle">
        <div
          v-html="vacancy[1].conditions_transport"
          class="vacancy-element__text  text"></div>

      </div>
    </div>

    <div v-if="hasClothes" :class="{_open: isOpen(5)}"
         class="vacancy-page__element  vacancy-element">
      <div class="vacancy-element__head" @click="onToggle(5)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-condition-clothes"
                   width="3.2rem"
                   height="3.2rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">
          {{ $tVacancy('Providing a working form') }}
          <template v-if="vacancy[1].conditions_clothes_type">
            - {{ vacancy[1].conditions_clothes_type.name }}
          </template>
        </h4>
        <div v-if="vacancy[1].conditions_clothes" class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>

      <div v-if="vacancy[1].conditions_clothes"
           class="vacancy-element__toggle">
        <div v-html="vacancy[1].conditions_clothes"
             class="vacancy-element__text  text"></div>
      </div>
    </div>

    <div v-if="hasAdditional" :class="{_open: isOpen(6)}"
         class="vacancy-page__element  vacancy-element">
      <div class="vacancy-element__head" @click="onToggle(6)">
        <div class="vacancy-element__ico-wrap">
          <BaseSvg name="ico-condition-other"
                   width="3.6rem"
                   height="3.6rem"
                   class="vacancy-element__ico"/>
        </div>
        <h4 class="vacancy-element__title">
          {{ $tVacancy('Additional conditions') }}
        </h4>
        <div v-if="vacancy[1].conditions_additional"
             class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
          <BaseSvg name="ico-arrow-down"/>
        </div>
      </div>

      <div v-if="vacancy[1].conditions_additional"
           class="vacancy-element__toggle">
        <div v-html="vacancy[1].conditions_additional"
             class="vacancy-element__text  text"></div>
      </div>
    </div>


  </div>
</template>

<script>
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'
  import windowSizeMixin from '@/mixins/windowSizeMixin'

  export default {
    name: 'VacancyConditionsSection',
    mixins: [windowSizeMixin],
    props: ['vacancy'],
    data() {
      return {
        WINDOW_SIZE_SM,
        toggleSections: []
      }
    },
    computed: {
      hasObservationHousing() {
        const section = this.vacancy[1]
        return section.conditions_observation_housing
          || section.conditions_observation_housing_type
      },
      hasHousing() {
        const section = this.vacancy[1]
        return section.conditions_housing
          || section.conditions_housing_type
          || section.conditions_housing_description
      },
      hasMeals() {
        const section = this.vacancy[1]
        return section.conditions_meals
          || section.conditions_meals_type
      },
      hasTransport() {
        const section = this.vacancy[1]
        return section.conditions_transport
          || section.conditions_transport_type
      },
      hasClothes() {
        const section = this.vacancy[1]
        return section.conditions_clothes
          || section.conditions_clothes_type
      },
      hasAdditional() {
        const section = this.vacancy[1]
        return section.conditions_additional
      },
      hasAny() {
        return this.hasObservationHousing
          || this.hasHousing
          || this.hasMeals
          || this.hasTransport
          || this.hasClothes
          || this.hasAdditional
      }
    },
    methods: {
      isOpen(id) {
        return this.toggleSections.some(item => item === id)
      },
      onToggle(id) {
        if (window.innerWidth > WINDOW_SIZE_SM) return
        if (this.isOpen(id)) {
          this.toggleSections = this.toggleSections.filter(item => item !== id)
        } else {
          this.toggleSections.push(id)
        }
      }
    },
  }
</script>

<style>

</style>
